"use client";

import Modal from "@/components/modal";
import { Button } from "@/components/ui/button";
import ContactForm from "@/app/[locale]/_components/contact-form";
import { Link } from "@/i18n/routing";
import { CalendarIcon, MailIcon } from "lucide-react";
import { useTranslations } from "next-intl";

export function BlogCta() {
  const t = useTranslations("Home");

  return (
    <section className="mt-16 border-t border-border pt-12">
      <div className="rounded-xl border border-border bg-card/50 p-8 text-center">
        <h3 className="text-xl font-semibold text-foreground">
          {t("sections.contactForm.title")}
        </h3>
        <p className="mt-3 text-muted-foreground max-w-lg mx-auto">
          {t("sections.contactForm.description")}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 mt-6">
          <Modal
            title={t("sections.contactForm.title")}
            description={t("sections.contactForm.description")}
            trigger={
              <Button type="button" size="lg">
                <MailIcon className="size-4" />
                {t("buttons.getInTouch")}
              </Button>
            }
          >
            <ContactForm />
          </Modal>
          <Link
            href="https://calendly.com/alaindifabio/discovery-call"
            target="_blank"
          >
            <Button type="button" variant="outline" size="lg">
              <CalendarIcon className="size-4" />
              {t("buttons.bookACall")}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
